import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { TokenUsageProgress } from "./components/token-usage/TokenUsageProgress";
import { RecentUsage } from "./components/token-usage/RecentUsage";
import { useTokenStats } from "./components/token-usage/useTokenStats";
import { useAuth } from "@/components/auth/AuthProvider";

export function TokenUsageCard() {
  const { user } = useAuth();
  const { stats: tokenStats, isLoading } = useTokenStats(user?.id);

  // Calculate usage percentage
  const usagePercentage = tokenStats ? (tokenStats.tokensUsed / tokenStats.monthlyTokens) * 100 : 0;

  return (
    <Card className="overflow-hidden">
      <CardHeader className="space-y-1 p-4 md:p-6">
        <CardTitle className="text-lg md:text-xl font-semibold break-words">
          Token Forbruk
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4 md:p-6 space-y-6">
        <div className="space-y-4">
          <TokenUsageProgress 
            usagePercentage={usagePercentage}
            tokensUsed={tokenStats?.tokensUsed || 0}
            monthlyTokens={tokenStats?.monthlyTokens || 0}
          />
          <RecentUsage 
            recentUsage={tokenStats?.recentUsage}
          />
        </div>
      </CardContent>
    </Card>
  );
}